import { TransferClientCapableFlow } from '@square/dashboard-protos/models/squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step';
import { BannerV2Format } from '@square/dashboard-protos/models/squareup/messageservice/service';
import { BannerDescription } from '@square/dashboard-protos/models/squareup/bbfrontend/common/component/component';
export let ClientFlow = /*#__PURE__*/function (ClientFlow) {
  ClientFlow["LINK_BANK_ACCOUNT"] = "LINK_BANK_ACCOUNT";
  ClientFlow["LINK_DEBIT_CARD"] = "LINK_DEBIT_CARD";
  ClientFlow["INSTANT_TRANSFER_LINK_BANK_ACCOUNT_THEN_DEBIT_IF_NECESSARY"] = "INSTANT_TRANSFER_LINK_BANK_ACCOUNT_THEN_DEBIT_IF_NECESSARY";
  return ClientFlow;
}({});
export function clientFlowEnumToString(clientFlow) {
  switch (clientFlow) {
    case TransferClientCapableFlow.LINK_BANK_ACCOUNT:
      {
        return ClientFlow.LINK_BANK_ACCOUNT;
      }
    case TransferClientCapableFlow.LINK_DEBIT_CARD:
      {
        return ClientFlow.LINK_DEBIT_CARD;
      }
    case TransferClientCapableFlow.INSTANT_TRANSFER_LINK_BANK_ACCOUNT_THEN_DEBIT_IF_NECESSARY:
      {
        return ClientFlow.INSTANT_TRANSFER_LINK_BANK_ACCOUNT_THEN_DEBIT_IF_NECESSARY;
      }
    default:
      return '';
  }
}
export function mapBannerVariantToBannerV2Type(variant) {
  switch (variant) {
    case BannerDescription.BannerVariant.BANNER_VARIANT_INFO:
      return BannerV2Format.BannerV2Type.BANNER_V2_TYPE_INFO;
    case BannerDescription.BannerVariant.BANNER_VARIANT_CRITICAL:
      return BannerV2Format.BannerV2Type.BANNER_V2_TYPE_CRITICAL;
    case BannerDescription.BannerVariant.BANNER_VARIANT_WARNING:
    default:
      return BannerV2Format.BannerV2Type.BANNER_V2_TYPE_WARNING;
  }
}